/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ProfileSettings {
  angular.module("meevo.plugins.profileSettings", []);
}